/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface ConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
  text: any;
  chefData: any;
  handleConfirm: (email: any) => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  handleClose,
  text,
  chefData,
  handleConfirm,
}) => {
  const navigate = useNavigate();

  const handleCancelClick = () => {
    // Optionally call handleClose first
    handleClose();  
    navigate("/login");  
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div className="card-body text-center">
              <h5 className="card-title text-success fw-bold">{text}</h5>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <button
            className="btn btn-cancel rounded-5 px-5 mt-2 mb-2"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary rounded-5 px-5 mt-2 mb-2"
            onClick={() => handleConfirm(chefData)}
          >
            Yes, Update
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;